import { UseInfiniteQueryResult } from "@tanstack/react-query";
import { RefObject } from "react";

import RequestLogs from "./RequestLogs";
import Spans from "./Spans";

import { Request } from "@/types/requests";

export { default as NoResultsFooter } from "./NoResultsFooter";
export { default as RequestLogs } from "./RequestLogs";
export { default as Spans } from "./Spans";

interface ContentProps {
  inputRef: RefObject<HTMLInputElement | null>;
  requestsOn: boolean;
  requests: Request[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  requestLogs: UseInfiniteQueryResult<any, unknown>;
  secondarySidebarOpen?: boolean;
}

const Content = ({
  inputRef,
  requestsOn,
  requests,
  requestLogs,
  secondarySidebarOpen = true,
}: ContentProps) => (
  <div className="flex min-h-0 flex-1 flex-col">
    {requestsOn ? (
      <RequestLogs
        inputRef={inputRef}
        requestsOn={requestsOn}
        requests={requests}
        requestLogs={requestLogs}
        secondarySidebarOpen={secondarySidebarOpen}
      />
    ) : (
      <Spans inputRef={inputRef} secondarySidebarOpen={secondarySidebarOpen} />
    )}
  </div>
);

export default Content;
